gsap.registerPlugin(ScrollTrigger);
const isMobile = detectMobileDevice()

const imageSpan = document.querySelector('.images-ZoomIn-section-img-box-dec-sub-title-span')

function detectMobileDevice() {
    const maxWidth = 768

    return window.innerWidth <= maxWidth
}

function zoomIn () {
    gsap.to(".images-ZoomIn-section-img-item", {
        scrollTrigger: {
            trigger: ".images-ZoomIn-section",
            markers: true,
            start: "center bottom",
            end: "center bottom",
            scrub: true,
        },
        scale: 1,
        y: 0,
    });
    gsap.to(".images-ZoomIn-section-img-box-dec-sub-title-span", {
        scrollTrigger: {
            trigger: ".images-ZoomIn-section",
            markers: false,
            start: "center bottom",
            end: "center bottom",
            scrub: true
        },
        color: '#fff',
    });
    gsap.to(".images-ZoomIn-section-img-box-dec-sub-title-span", {
        scrollTrigger: {
            trigger: ".images-ZoomIn-section",
            markers: false,
            start: "center bottom",
            end: "center bottom",
            scrub: true,
            onEnter: function(){
                imageSpan.classList.add('active')
            },
            onLeaveBack: function(){
                imageSpan.classList.remove('active')
            }
        }
    });
    gsap.to(".images-ZoomIn-section-img-box-dec-sub-title", {
        scrollTrigger: {
            trigger: ".images-ZoomIn-section",
            markers: false,
            start: "center bottom",
            end: "center bottom",
            scrub: true,
        },
        color:'#fff',
    });
    gsap.to(".images-ZoomIn-section-img-box-dec-title", {
        scrollTrigger: {
            trigger: ".images-ZoomIn-section",
            markers: false,
            start: "center bottom",
            end: "center bottom",
            scrub: true,
        },
        color:'#fff',
    });
    gsap.to(".images-ZoomIn-section-img-box-dec-text", {
        scrollTrigger: {
            trigger: ".images-ZoomIn-section",
            markers: false,
            start: "center bottom",
            end: "center bottom",
            scrub: true,
        },
        color:'#fff',
    });
}

window.onload = function () {
    // ios 사파리 vh 문제해결 js코드 + css 연동
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
    AOS.init();
    zoomIn();
}


